export default __webpack_public_path__ + "static/media/spinner.757857ce.gif";